import { writable } from 'svelte/store';
export const emptyWorksite = {
    id: 0,
    title_fr: "",
    title_en: "",
    status_id: "",
    goals: [],
    leaders: [],
    participants: [],
    deliverables: [],
};
export const storeWorksites = writable([]);
export const storeWorksitesError = writable("");
export const storeWorksite = writable(emptyWorksite);
